import React from "react";
import { Button, Link } from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";

const FilledButton = ({
  title,
  color = "#FFF",
  bgColor = "#a20c0b",
  url,
  px = "5",
  ...props
}) => {
  return (
    <>
      <Link
        as={RouterLink}
        to={url}
        onClick={() => {
          window.scrollTo({ top: "0", behavior: "auto" });
        }}
        overlay="none"
        _hover={{ textDecoration: "none" }}
      >
        <Button
          border="1px solid #a20c0b"
          borderRadius="full"
          bgColor={bgColor}
          color={color}
          boxShadow="rgba(0, 0, 0, 0.02) 0px 1px 3px 0px"
          w="fit-content"
          px={px}
          fontWeight="600"
          fontSize={{ base: "14px", md: "16px" }}
          transition="all 250ms"
          _hover={{
            borderColor: "#a20c0b",
            boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px",
            transform: "translateY(-1px)",
          }}
          _active={{
            backgroundColor: "#F0F0F1",
            borderColor: "#a20c0b",
            boxShadow: "rgba(0, 0, 0, 0.06) 0px 2px 4px",
            transform: "translateY(0)",
          }}
          {...props}
        >
          {title}
        </Button>
      </Link>
    </>
  );
};

export default FilledButton;
